/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",

  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "wrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",

  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

export default function Table039({ formData, setFieldValue }) {
  const [data1, setData1] = useState([
    {
      id: uuidV4(),
      projectName: "",
      number: "",
      day: "",
      province: "Tỉnh A",
      district: "",
      cqtA: "",
      cqtB: "",
      tax7: 0,
      tax8: 0,
      tax9: 0,
      tax10: 0,
    },
  ]);

  const [data2, setData2] = useState([
    {
      id: uuidV4(),
      projectName: "",
      number: "",
      day: "",
      province: "Tỉnh A",
      district: "",
      cqtA: "",
      cqtB: "",
      tax7: 0,
      tax8: 0,
      tax9: 0,
      tax10: 0,
    },
  ]);

  const [data, setData] = useState([
    {
      id: uuidV4(),
      projectName: "",
      number: "",
      day: "",
      province: "Tỉnh A",
      district: "",
      cqtA: "",
      cqtB: "",
      tax7: 0,
      tax8: 0,
      tax9: 0,
      tax10: 0,
    },
  ]);
  const handleChange1 = (values) => {
    const { id, name, value, type } = values;
    setData1((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data1 });
  };
  const handleChange2 = (values) => {
    const { id, name, value, type } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data2 });
  };
  const handleChange = (values) => {
    const { id, name, value, type } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data });
  };
  const handleChangeDate = (date, id) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd = () => {
    setData((prev) => [
      ...prev,
      {
        id: uuidV4(),
        projectName: "",
        number: "",
        day: "",
        province: "Tỉnh A",
        district: "",
        cqtA: "",
        cqtB: "",
        tax7: 0,
        tax8: 0,
        tax9: 0,
        tax10: 0,
      },
    ]);
  };
  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Tên dự án bất động sản
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Số chứng từ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Ngày chứng từ
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Địa bàn hoạt động kinh doanh bất động sản
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center" }}>
                Tên cơ quan thu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền thu theo tiến độ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN đã tạm nộp
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số thuế TNDN đã tạm nộp bù trừ với số thuế phải nộp theo quyết toán kỳ này
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center" }}>
                Số tiền thuế đã tạm nộp chưa quyết toán chuyển kỳ sau
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>Tỉnh</Td>
              <Td style={{ textAlign: "center" }}>Huyện</Td>
              <Td style={{ textAlign: "center" }}>Cơ quan Thuế cấp Cục</Td>
              <Td style={{ textAlign: "center" }}>Cơ quan Thuế cấp chi Cục</Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (3)
              </Td>
              <Td style={{ textAlign: "center" }}>(5)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td colSpan={2} style={{ textAlign: "center" }}>
                (6)
              </Td>
              <Td style={{ textAlign: "center" }}>(7)</Td>
              <Td style={{ textAlign: "center" }}>(8)</Td>
              <Td style={{ textAlign: "center" }}>(9)</Td>
              <Td style={{ textAlign: "center" }}>(10)</Td>
            </tr>
            {/*  */}
            <tr>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                1
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
                colSpan={3}
              >
                Thuế TNDN đã tạm nộp của hoạt động chuyển nhượng bất động sản chưa quyết toán trong
                các kỳ trước
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td>
                <InputTable
                  id={data1[0].id}
                  name="tax8"
                  value={data1[0].tax8}
                  onChange={handleChange1}
                />
              </Td>
              <Td>
                <InputTable
                  id={data1[0].id}
                  name="tax9"
                  value={data1[0].tax9}
                  onChange={handleChange1}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data1[0].id}
                  name="tax10"
                  value={data1[0].tax10}
                  onChange={handleChange1}
                />
              </Td>
            </tr>
            {/*  */}
            <tr>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data1[0].id}
                  name="tax7"
                  value={data1[0].tax7}
                  onChange={handleChange1}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data1[0].id}
                  name="tax8"
                  value={data1[0].tax8}
                  onChange={handleChange1}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data1[0].id}
                  name="tax9"
                  value={data1[0].tax9}
                  onChange={handleChange1}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data1[0].id}
                  name="tax10"
                  value={data1[0].tax10}
                  onChange={handleChange1}
                />
              </Td>
            </tr>
            {/*  */}
            <tr>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                2
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
                colSpan={3}
              >
                Thuế TNDN đã tạm nộp theo tiến độ trong kỳ này
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data1[0].id}
                  name="tax8"
                  value={data1[0].tax8}
                  onChange={handleChange1}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data1[0].id}
                  name="tax9"
                  value={data1[0].tax9}
                  onChange={handleChange1}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data1[0].id}
                  name="tax10"
                  value={data1[0].tax10}
                  onChange={handleChange1}
                />
              </Td>
            </tr>
            {/*  */}
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  2.{+index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="projectName"
                    value={item.projectName}
                    onChange={handleChange}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="number"
                    value={item.number}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <DatePicker
                    style={{
                      fontSize: 13,
                      color: "#495057",
                      border: "0.0625rem solid #d2d6da",
                      background: "#fff",
                      padding: "0.5rem 0.75rem",
                      width: "100%",
                      borderRadius: "0.5rem",
                    }}
                    options={{
                      locale: Vietnamese,
                      time_24hr: true,
                      dateFormat: "d-m-Y",
                    }}
                    name="day"
                    value={item.day}
                    onChange={(date) => handleChangeDate(date, item.id)}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "province", e.target.value)}
                  >
                    <option value="Tỉnh A">Tỉnh A</option>
                    <option value="Tỉnh B">Tỉnh B</option>
                    <option value="Tỉnh C">Tỉnh C</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "district", e.target.value)}
                  >
                    <option value="Huyện A">Huyện A</option>
                    <option value="Huyện B">Huyện B</option>
                    <option value="Huyện C">Huyện C</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "cqtA", e.target.value)}
                  >
                    <option value="value1">Cơ quan thuế A</option>
                    <option value="value2">Cơ quan thuế B</option>
                    <option value="value3">Cơ quan thuế C</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "cqtB", e.target.value)}
                  >
                    <option value="value1">Cơ quan thuế A</option>
                    <option value="value2">Cơ quan thuế B</option>
                    <option value="value3">Cơ quan thuế C</option>
                  </select>
                </Td>
                <Td>
                  <InputTable id={item.id} name="tax7" value={item.tax7} onChange={handleChange} />
                </Td>
                <Td>
                  <InputTable id={item.id} name="tax8" value={item.tax8} onChange={handleChange} />
                </Td>
                <Td>
                  <InputTable id={item.id} name="tax9" value={item.tax9} onChange={handleChange} />
                </Td>
                <Td
                  style={{
                    background: "#ddeff3",
                  }}
                >
                  <InputTable
                    readOnlyBackground={true}
                    readOnly={true}
                    id={item.id}
                    name="tax10"
                    value={item.tax10}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            {/*  */}
            <tr>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              >
                3
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
                colSpan={3}
              >
                Tổng số thuế TNDN đã tạm nộp của hoạt động chuyển nhượng bất động sản chưa quyết
                toán chuyển các kỳ sau
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td>
                <InputTable
                  id={data2[0].id}
                  name="tax8"
                  value={data2[0].tax8}
                  onChange={handleChange2}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data2[0].id}
                  name="tax9"
                  value={data2[0].tax9}
                  onChange={handleChange2}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data2[0].id}
                  name="tax10"
                  value={data2[0].tax10}
                  onChange={handleChange2}
                />
              </Td>
            </tr>
            {/*  */}
            <tr>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              ></Td>
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                  textAlign: "center",
                  fontWeight: "bold",
                }}
              />
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data2[0].id}
                  name="tax7"
                  value={data2[0].tax7}
                  onChange={handleChange2}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data2[0].id}
                  name="tax8"
                  value={data2[0].tax8}
                  onChange={handleChange2}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data2[0].id}
                  name="tax9"
                  value={data2[0].tax9}
                  onChange={handleChange2}
                />
              </Td>
              <Td
                style={{
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  readOnlyBackground={true}
                  readOnly={true}
                  id={data2[0].id}
                  name="tax10"
                  value={data2[0].tax10}
                  onChange={handleChange2}
                />
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        minWidth: 180,
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
